export const LOCAL_STORAGE = {
  DIGITAL_PROGRAMS_USER: 'digital-programs-user',
};
